package dev.kuml.portal.web.i18n.strings

/** Backs the global usage/plan chip ([dev.kuml.portal.web.usage.usageChip],
 * [dev.kuml.portal.web.usage.UsageFormat]). Plan-name formatting itself lives in
 * [dev.kuml.portal.web.i18n.format.LocaleFormat.planLabel] (a locale-formatting concern, not a
 * fixed-vocabulary string) -- this interface only covers the two unit words. */
public interface UsageStrings {
    public val projectsUnit: String
    public val aiGenerationsUnit: String

    public val allPlainStrings: List<String> get() = listOf(projectsUnit, aiGenerationsUnit)
}

public object UsageStringsDe : UsageStrings {
    override val projectsUnit = "Projekte"
    override val aiGenerationsUnit = "KI-Generierungen"
}

public object UsageStringsEn : UsageStrings {
    override val projectsUnit = "projects"
    override val aiGenerationsUnit = "AI generations"
}
